import logger from '@/app/logger';
import type { FiltersType } from '@/schemas/filtersSchema';
import { defineStore } from 'pinia';

export const useFilterStore = defineStore('filterStore', {
  state: () => ({ filters: {} }),
  actions: {
    setFilters(filters: FiltersType) {
      logger.info('Storing filters in state:', { filters });
      const nonEmptyFilters = { ...filters };
      Object.keys(nonEmptyFilters).forEach((key) => {
        if (!nonEmptyFilters[key as keyof FiltersType]) {
          delete nonEmptyFilters[key as keyof FiltersType]; // Remove undefined filter
        }
      });
      this.filters = nonEmptyFilters;
    },
  },
});
